import * as React from 'react';
import * as styles from './tooltip.module.sass';
import {SFC} from 'react';

export interface IAuthTooltipProps {
  children?: any;
  disabled?: boolean;
  label: string;
}

export const AuthTooltip: SFC<IAuthTooltipProps> = ({
  children,
  disabled,
  label,
}) => {
  if (disabled || !label) {
    return (
      <>
        {children}
      </>
    );
  }

  return (
    <div className={styles['tooltip']}>
      <div className={styles['tooltip__label']}>
        {label}
      </div>

      {children}
    </div>
  );
};
